import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=d6316932"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports